import { tsv, autoType } from 'd3';
import { readable } from 'svelte/store';

const itemsURL = './data/data.tsv';

const parseRow = ({
  company_common_name,
  trbc_industry_group_name,
  umap_x,
  umap_y,
  ...d
}) => ({
  ...d,
  label: company_common_name,
  industry: trbc_industry_group_name,
  x: umap_x,
  y: umap_y,
});

export const dataSet = readable({ items: [] }, set => {
  Promise.all([tsv(itemsURL, autoType)]).then(([_items]) => {
    const items = _items.map(parseRow);
    set({ items });
  });
});
